var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('basic-container',[_c('iframe',{attrs:{"width":"100%","height":"900px","src":_vm.iframeUrl,"id":"reportFrame","frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }